import { AllBoosters } from '@/features/boosters/hooks/useBoosters';

import { BoosterType } from '@/shared/types/Billing';

const formatCurrency = (cents: number, currency = 'USD') =>
  new Intl.NumberFormat('en-US', { currency, style: 'currency' }).format(cents / 100);

export const formatBoosterPrice = (
  allBoosters: AllBoosters | null,
  boosterType: BoosterType,
  quantity = 1,
): string => {
  const booster = allBoosters?.[boosterType];
  const currency = booster?.prices[0]?.currency ?? 'USD';
  const totalCents = (booster?.price ?? 0) * quantity;

  return formatCurrency(totalCents, currency);
};

export const formatBoosterSeatsText = (seatsCount: number, allBoosters: AllBoosters | null): string => {
  const price = formatBoosterPrice(allBoosters, BoosterType.TeamspaceSeat, seatsCount);
  const seatWord = seatsCount === 1 ? 'seat' : 'seats';

  return `Add ${seatsCount} ${seatWord} for ${price}/per month`;
};
